<template>
  <header>
    <div class="header-wrapper d-flex justify-content-center">
      <div class="logo">
        <router-link to="/">
          <img src="/static/images/header/logo.png" alt="おひさまキッチン ロゴ画像" class="img-fluid">
        </router-link>
      </div>
    </div>

    <b-link v-b-toggle.collapse-1 class="global-menu-button">
      <img src="/static/images/menu/button.png" alt="メニューボタン" class="img-fluid">
    </b-link>

    <b-collapse id="collapse-1" class="global-menu-list">
      <ul class="list-unstyled">
        <li class="line-section">
          <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
        </li>
        <li>
          <router-link v-b-toggle.collapse-1 to="/">
            <img src="/static/images/menu/top.png" alt="トップページ" class="img-fluid">
          </router-link>
        </li>
        <li class="line-section">
          <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
        </li>
        <li>
          <router-link v-b-toggle.collapse-1 to="/ehon.html">
            <img src="/static/images/menu/ehon.png" alt="えほん" class="img-fluid">
          </router-link>
        </li>
        <li class="line-section">
          <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
        </li>
        <li>
          <router-link v-b-toggle.collapse-1 to="/dance.html">
            <img src="/static/images/menu/dance.png" alt="パンダくんのダンスだよ" class="img-fluid">
          </router-link>
        </li>
        <li class="line-section">
          <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
        </li>
        <li>
          <router-link v-b-toggle.collapse-1 to="/taiken.html">
            <img src="/static/images/menu/taiken.png" alt="体験するえほん展と読み聞かせなど" class="img-fluid">
          </router-link>
        </li>
        <li class="line-section">
          <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
        </li>
        <li>
          <router-link v-b-toggle.collapse-1 to="/campaign.html">
            <img src="/static/images/menu/campaign.png" alt="ふしぎなプレゼントキャンペーン" class="img-fluid">
          </router-link>
        </li>
        <li class="line-section">
          <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
        </li>
        <li>
          <router-link v-b-toggle.collapse-1 to="/yomikikasetai.html">
            <img src="/static/images/menu/yomikikase.png" alt="よみきかせ隊がいきます！" class="img-fluid">
          </router-link>
        </li>
        <li class="line-section">
          <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
        </li>
        <li>
          <router-link v-b-toggle.collapse-1 to="/donguri.html">
            <img src="/static/images/menu/donguri.png" alt="どんぐり通貨" class="img-fluid">
          </router-link>
        </li>
        <li class="line-section">
          <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
        </li>
        <li>
          <a href="https://okaimono.ohisamak-ehonya.com" target="_blank">
            <img src="/static/images/menu/shop.png" alt="おかいもの" class="img-fluid">
          </a>
        </li>
        <li class="line-section">
          <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
        </li>
        <li>
          <router-link v-b-toggle.collapse-1 to="/houkoku.html">
            <img src="/static/images/menu/houkoku.png" alt="つくったよ報告隊！" class="img-fluid">
          </router-link>
        </li>
        <li class="line-section">
          <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
        </li>
        <li>
          <b-link v-b-toggle.collapse-sub class="sub-menu-button">
            <img src="/static/images/menu/sekai.png" alt="おひさまキッチンの世界" class="img-fluid">
          </b-link>
          <b-collapse id="collapse-sub" class="sub-menu-list">
            <ul class="list-unstyled">
              <li class="line-section">
                <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
              </li>
              <li>
                <router-link v-b-toggle.collapse-1 to="/introduce.html">
                  <img src="/static/images/menu/introduce.png" alt="どうぶつさんしょうかい" class="img-fluid">
                </router-link>
              </li>
              <li class="line-section">
                <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
              </li>
              <li>
                <a href="/ohisama/ehon.html">
                  <img src="/static/images/menu/anime.png" alt="動物さんたちのアニメ" class="img-fluid">
                </a>
              </li>
              <li class="line-section">
                <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
              </li>
              <li>
                <a href="/ohisama/map.html">
                  <img src="/static/images/menu/map.png" alt="おひさまキッチンマップ" class="img-fluid">
                </a>
              </li>
              <li class="line-section">
                <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
              </li>
              <li>
                <a href="/ohisama/ugokupandakun.html">
                  <img src="/static/images/menu/movepandakun.png" alt="今月のうごくパンダくん" class="img-fluid">
                </a>
              </li>
              <li class="line-section">
                <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
              </li>
              <li>
                <a href="/ohisama/wallpaper.html">
                  <img src="/static/images/menu/kabegami.png" alt="壁紙" class="img-fluid">
                </a>
              </li>
              <li class="line-section">
                <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
              </li>
              <li>
                <a href="/ohisama/201411_ehon/book.html">
                  <img src="/static/images/menu/babyehon.png" alt="ベビーパンダちゃんの絵本" class="img-fluid">
                </a>
              </li>
              <li class="line-section">
                <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
              </li>
              <li>
                <a href="/ohisama/spice.html">
                  <img src="/static/images/menu/kaorinote.png" alt="香りの草原かんさつノート" class="img-fluid">
                </a>
              </li>
              <li class="line-section">
                <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
              </li>
              <li>
                <a href="/ohisama/tree.html">
                  <img src="/static/images/menu/tree.png" alt="つぶや木、ささや木、イン木" class="img-fluid">
                </a>
              </li>
              <li class="line-section">
                <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
              </li>
              <li>
                <a href="/namaketodoke/" target="_blank">
                  <img src="/static/images/menu/namake.png" alt="なまけもののとどけもの" class="img-fluid">
                </a>
              </li>
              <li class="line-section">
                <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
              </li>
              <li>
                <a href="/ohisama/twitter_ehon/">
                  <img src="/static/images/menu/twitterstory.png" alt="twitter物語" class="img-fluid">
                </a>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li class="line-section">
          <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
        </li>
        <li>
          <router-link v-b-toggle.collapse-1 to="/otoiawase.html">
            <img src="/static/images/menu/info.png" alt="お問い合わせ" class="img-fluid">
          </router-link>
        </li>
        <li class="line-section">
          <img src="/static/images/menu/menu-line.png" alt="区切り線" class="img-fluid"/>
        </li>
      </ul>
    </b-collapse>
  </header>
</template>

<script>
  export default {
    data() {
      return {}
    },
    methods: {
      menuClick: function() {
        var menu_button = document.getElementsByClassName('global-menu-button')[0]
        var collapse = document.getElementById("collapse-1")

        if(menu_button.classList.contains("collapsed") == true) {
          menu_button.setAttribute("aria-expanded", "true")
          menu_button.classList.remove("collapsed")
          collapse.classList.add("show")
          collapse.setAttribute("style","")
        } else {
          menu_button.setAttribute("aria-expanded", "false")
          menu_button.classList.add("collapsed")
          collapse.classList.remove("show")
          collapse.setAttribute("style","display: none;")
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue